var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-icon',{staticClass:"tooltip-indicator",attrs:{"x-small":"","color":"grey lighten-2"}},[_vm._v("\n  mdi-information-variant\n")])}
var staticRenderFns = []

export { render, staticRenderFns }